// removed by extract-text-webpack-plugin
module.exports = {"list":"src-lib-components-list-__ReviewsList__list--36SC2","item":"src-lib-components-list-__ReviewsList__item--1l-I9","item-main":"src-lib-components-list-__ReviewsList__item-main--32xp4","item-side":"src-lib-components-list-__ReviewsList__item-side--3rZ6P","item-title":"src-lib-components-list-__ReviewsList__item-title--X23TY","item-content":"src-lib-components-list-__ReviewsList__item-content--3zaxg","item-meta":"src-lib-components-list-__ReviewsList__item-meta--1eBAv"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/list/ReviewsList.less
// module id = 1867
// module chunks = 0